import React from "react";
import { Link } from "react-router-dom";
import ThemeSetter from "./themeSetter";

const Navigation = ({ theme, onClick }) => {
  return (
    <header className="header">
      <div className="header-container flex">
        <Link className="logo" to="/">
          Where in the world?
        </Link>
        <ThemeSetter theme={theme} onclick={onClick} />
      </div>
    </header>
  );
};

export default Navigation;
